import { subHours } from 'date-fns'

// Start of today in UTC as ISO string
export function getTodayMinDateISO() {
    const today = new Date()
    today.setUTCHours(0, 0, 0, 0)
    return today.toISOString()
}

// End of today in UTC as ISO string
export function getTodayMaxDateISO() {
    const today = new Date()
    today.setUTCHours(23, 59, 59, 59)
    return today.toISOString()
}

/**
 * Formats a date using browser locale formatting (default: pl-PL).
 * Keeps the legacy API signature: (date, withTime = true, placeholder = true, options = {}).
 */
export function formatDate(date, withTime = true, placeholder = true, options = {}) {
    if (!date) {
        return placeholder ? '-' : ''
    }

    const value = new Date(date)

    return withTime ? value.toLocaleString('pl-PL', options) : value.toLocaleDateString('pl-PL', options)
}

/**
 * Parses a duration (seconds) to HH:mm:ss string.
 */
export function parseDuration(totalSeconds) {
    if (!totalSeconds || totalSeconds < 0) return '-'

    let remaining = totalSeconds
    let hours = Math.floor(remaining / 3600)

    remaining %= 3600

    let minutes = Math.floor(remaining / 60)
    const seconds = remaining % 60

    hours = String(hours).padStart(2, '0')
    minutes = String(minutes).padStart(2, '0')
    const secondsStr = String(seconds).padStart(2, '0')

    return `${hours}:${minutes}:${secondsStr}`
}

/**
 * Returns an ISO string representing current date/time minus given hours.
 */
export function withdrawalDate(hours) {
    return subHours(new Date(), hours).toISOString()
}

/**
 * Returns yyyy-MM-dd string for the day before given date.
 */
export function getDayBackward(date) {
    const current = new Date(date)
    const previous = new Date(current.getTime() - 24 * 60 * 60 * 1000)
    return previous.toJSON().slice(0, 10)
}

/**
 * Returns yyyy-MM-dd string for the day after given date.
 */
export function getDayForward(date) {
    const current = new Date(date)
    const next = new Date(current.getTime() + 24 * 60 * 60 * 1000)
    return next.toJSON().slice(0, 10)
}

/**
 * Converts seconds to full minutes (integer). Returns '-' for null input.
 */
export function convertToMinutes(totalSeconds) {
    if (totalSeconds === null || totalSeconds === undefined) return '-'
    return Math.floor(totalSeconds / 60)
}

/**
 * Normalizes an incoming date-like value to a plain yyyy-MM-dd string.
 * - Date instance -> first 10 chars of ISO string
 * - ISO/string with time -> truncated to first 10 chars
 * - short string (e.g. '2024-01-01') -> returned as is
 * - falsy/invalid -> null
 */
export function normalizeDateOnly(value) {
    if (!value) {
        return null
    }

    if (value instanceof Date) {
        const year = value.getFullYear()
        const month = String(value.getMonth() + 1).padStart(2, '0')
        const day = String(value.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
    }

    if (typeof value === 'string') {
        if (value.length >= 10) {
            return value.slice(0, 10)
        }
        return value
    }

    return value
}
